import { EventTypeProcess } from './EventTypeProcess';

export class EventTypeProcessInstance {
    constructor(sequenceNr: number | null, instanceDescription: string, evTypePrcList: EventTypeProcess[], isExpanded: boolean, isSelected: boolean) {
        this.sequenceNr = sequenceNr;
        this.instanceDescription = instanceDescription;
        this.evTypePrcList = evTypePrcList;
        this.isExpanded = isExpanded;
        this.isSelected = isSelected;
    }
    sequenceNr: number | null;
    instanceDescription: string;
    evTypePrcList: EventTypeProcess[];
    isExpanded: boolean;
    isSelected: boolean;
}
